import { defineStore } from 'pinia';

export const useGeneralStore = defineStore('generalStore', {
  state: () => ({
    isLoading: false,
    errorMessage: null
  }),
  actions: {
    updateIsLoading(isLoading) {
      this.isLoading = isLoading;
    },
    updateErrorMessage(message) {
      this.errorMessage = message;
    }
  },
});